<template>
  <v-menu offset-y bottom nudge-bottom="4" content-class="colab-dropdown-menu">
    <template v-slot:activator="{ on, attrs }">
      <button class="colab-toolbar-btn" aria-label="Mais opções" v-bind="attrs" v-on="on">
        <v-icon size="18">mdi-dots-vertical</v-icon>
      </button>
    </template>

    <v-card flat class="colab-dropdown-card">
      <div class="colab-dropdown-item colab-dropdown-delete" @click.prevent="removerTodasColaboracoesExibidas">
        <v-icon small class="mr-3">mdi-delete-outline</v-icon>
        <span>Remover todas as exibidas</span>
      </div>
      <div class="colab-dropdown-item colab-dropdown-unfav" @click.prevent="desfavoritarTodasColaborações">
        <v-icon small class="mr-3">mdi-heart-off-outline</v-icon>
        <span>Desfavoritar todas</span>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions } from "vuex";
export default {
  props: {
    fetchColaboracoesAprovadas: Function,
  },
  methods: {
    ...mapActions({ zerarTotalItems: "colaboracoes_aprovadas/zerarTotalItems" }),
    async removerTodasColaboracoesExibidas() {
      try {
        const payload = {
          cod_producao: this.$store.state.producoes.selectedProducao?.cod_producao,
          dsc_login_usuario: this.$store.state.users.user.dsc_login_usuario,
        };

        const response = await apiClient.patch(
          `/removerTodasColaboracoesExibidas`,
          payload
        );

        if (response.status === 200) {
          this.zerarTotalItems({
            totalItems: this.$store.state.colaboracoes_aprovadas.colaboracoes
              .colaboracoes_exibidas.totalItems,
            flg_favorita_ou_exibida: "flg_exibida",
          });

          await this.fetchColaboracoesAprovadas();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || "Erro ao remover colaborações exibidas");
      }
    },
    async desfavoritarTodasColaborações() {
      try {
        const payload = {
          cod_producao: this.$store.state.producoes.selectedProducao?.cod_producao,
        };

        const response = await apiClient.patch(`/desfavoritarTodasColaboracoes`, payload);

        if (response.status === 200) {
          this.zerarTotalItems({
            totalItems: this.$store.state.colaboracoes_aprovadas.colaboracoes
              .colaboracoes_favoritas.totalItems,
            flg_favorita_ou_exibida: "flg_favorita",
          });
          await this.fetchColaboracoesAprovadas();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || "Erro ao desfavoritar colaborações");
      }
    },
  },
};
</script>

<style lang="scss">
.colab-dropdown-menu {
  border-radius: var(--sc-radius-lg) !important;
}
</style>

<style lang="scss" scoped>
.colab-toolbar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 34px;
  background: transparent;
  border: 1px solid var(--sc-border-default);
  border-radius: var(--sc-radius-md);
  cursor: pointer;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);

  .v-icon {
    color: var(--v-text_secondary-base) !important;
    opacity: 0.6;
    transition: all var(--sc-duration-base) var(--sc-easing-standard);
  }

  &:hover {
    border-color: var(--v-primary-base);
    background: rgba(var(--sc-color-primary-rgb),0.08);
    .v-icon { opacity: 1; color: var(--v-primary-base) !important; }
  }
}

.colab-dropdown-card {
  background: var(--v-surface_secondary-base) !important;
  border-radius: var(--sc-radius-lg) !important;
  overflow: hidden;
  min-width: 240px;
  padding: 6px;
}

.colab-dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: var(--sc-radius-md);
  cursor: pointer;
  transition: background var(--sc-duration-fast) var(--sc-easing-standard);
  color: var(--v-text_primary-base);
  font-size: var(--sc-text-base);
  font-weight: 500;

  &:hover {
    background: var(--sc-surface-tint-hover);
  }
}

.colab-dropdown-delete:hover {
  background: rgba(var(--sc-color-error-rgb),0.08);
  .v-icon { color: var(--v-error-base) !important; }
  color: var(--v-error-base);
}

.colab-dropdown-unfav:hover {
  background: rgba(255, 193, 7, 0.08);
  .v-icon { color: var(--sc-color-feature) !important; }
}
</style>
